import {Directive, HostListener, Input} from '@angular/core';

@Directive({
    selector: 'input[preventNumber]',
    standalone: false
})
export class PreventLettersDirective {
    @Input() disablePrevent: boolean = false


    @HostListener('keydown', ['$event'])
    // @ts-ignore
    onInput(event: KeyboardEvent) {
        // if (this.disablePrevent)
        //     return;
        // let input = event.key.toLowerCase();
        // if (input.match(/[a-z]/) && input.length === 1){
        //     event.preventDefault();
        // }else{
        //     return
        // }
    }
}